import React, { useEffect, useState } from "react";
import { callAPI, useStore, usePage, useUser } from "../../Utils/utils";
import { useNavigate } from "react-router-dom";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import CategoryList from '../../Components/Category/CategoryList/CategoryList'
import Button from "../../Components/Global/Button";
import Pagination from "../../Components/Global/Pagination/Pagination";
import Loader from "../../Components/Global/Loader/Loader";
import { category_page_labels } from "../../Constants/Labels";
import { select_store_message, categories_page_message } from "../../Constants/Messages";
import Alert from "../../Components/Alert/Alert";

const CategoriesPage = () => {

    const navigate = useNavigate();
    const { user, setUser } = useUser();
    const { page, setPage } = usePage();
    const { store, setStore } = useStore()
    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState('active')
    const [alert, setAlert] = useState()
    const [searchValue, setSearchValue] = useState()
    const [searchResult, setSearchResult] = useState()
    const [currentPage, setCurrentPage] = useState(1)
    const [payLoad, setPayLoad] = useState()
    const [resultInfo, setResultInfo] = useState({
        total_rows: "",
        fetched_rows: "",
        total_pages: "",
        page_size: 0,
        current_page: "",
        success: true,
        errors: ""
    })

    // get store id from context and stor in store_id variable
    var store_id = store?.id

    useEffect(() => {
        setPage({ isLoading: loading })
    }, [loading])

    useEffect(() => {
        var SavedMessage = localStorage.getItem('Message')
        if (SavedMessage != null) {
            setAlert({ text: SavedMessage, type: "error" })
        }
    }, [])

    useEffect(() => {

        var inital_pay_load = {
            "store_id": store_id,
            "status": mode,
            "current_page": currentPage
        }

        var pay_load = payLoad || inital_pay_load
        if (pay_load.status != mode) {
            pay_load.status = mode
            pay_load.current_page = 1
        }
        callAPI('/admin/category/by-store',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            }, navigate, setLoading)
            .then(data => {
                // console.log("api response " + JSON.stringify(data))
                if (data.success) {
                    setSearchResult(data.records)
                    setResultInfo({
                        total_rows: data.total_rows,
                        fetched_rows: data.fetched_rows,
                        total_pages: data.total_pages,
                        page_size: data.page_size,
                        current_page: data.current_page,
                        success: data.success,
                        errors: data.errors
                    })
                } else {
                    // console.log('Error occurred. Please try again.')
                }
            })
    }, [mode, store_id, payLoad])

    const onChangeSearchValue = (event) => {
        setSearchValue(event.target.value)
        var pay_load = {
            "store_id": store_id,
            "status": mode,
            "current_page": 1
        }
        if (event.target.value) {
            pay_load.filters = {
                "conditions": [
                    { "field": store?.is_separate_store? "name" : "c.name", "operator": "like", "value": event.target.value, "dataType": "string" }
                ]
            }
        }
        setPayLoad(pay_load)
    }

    const getSearchResult = (currentPage) => {
        var pay_load = {
            "store_id": store_id,
            "status": mode,
            "current_page": currentPage
        }
        if (searchValue) {
            pay_load.filters = {
                "conditions": [
                    { "field": "name", "operator": "like", "value": searchValue, "dataType": "string" }
                ]
            }
        }
        setPayLoad(pay_load)
    }

    //on enter search the store list
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            getSearchResult()
        }
    }

    const onPageSelect = (currentPage) => {
        setCurrentPage(currentPage)
        onClickSearchBtn(currentPage)
    }

    //during on search icon clicked get the result of store
    const onClickSearchBtn = (currentPage) => {
        getSearchResult(currentPage)
    }

    let select_store = store?.id == null || store?.id == undefined || store?.id == 0 || store?.name == "Global Admin" ? true : false
    let isSeparateStore = store?.is_separate_store === true

    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
                {isSeparateStore && <Button className={'btn btn-primary'} onClick={() => navigate('/admin/category/new')} value={category_page_labels?.category_add_page_labels?.title} />}
            </div>

            {alert?.text == categories_page_message?.deleted_message ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}

            {select_store ?
                <div className="ec-store-list card card-default">
                    <div className="card-body  select_store">
                        <p className="text-center">{select_store_message?.select_store}</p>
                    </div>
                </div>
                :
                <div className="cardWrapper card-default">
                    <div className="card-body">
                        <div className="table-responsive">
                            <div className="dataTables_wrapper">
                                <div className="filterTab mb-3">
                                    <div className="navAndSearchWrapper">
                                        <ul className="nav nav-tabs nav-style-border w-75">
                                            <li className="nav-item" onClick={() => setMode('active')}>
                                                <span className={`nav-link ${mode == 'active' ? 'active' : ''}`}>{category_page_labels?.category_page_tab_labels?.active}</span>
                                            </li>
                                            <li className="nav-item" onClick={() => setMode('inactive')}>
                                                <span className={`nav-link ${mode == 'inactive' ? 'active' : ''}`}>{category_page_labels?.category_page_tab_labels?.inactive}</span>
                                            </li>
                                            <li className="nav-item" onClick={() => setMode('all')}>
                                                <span className={`nav-link ${mode == 'all' ? 'active' : ''}`}>{category_page_labels?.category_page_tab_labels?.all}</span>
                                            </li>
                                        </ul>

                                        <div className="search-form">
                                            <div className="input-group">
                                                <input type="text" className="form-control"
                                                    placeholder={`${category_page_labels?.category_page_search_placeholder_label}`} onChange={onChangeSearchValue} onKeyDown={handleKeyDown} />
                                                <span className="search_icon" >
                                                    <i className="mdi mdi-magnify"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {loading &&
                                    <Loader className={"table_loader"} />
                                }

                                {/* list Customer Based on store  */}
                                <CategoryList config={searchResult} mode={mode} searchResult={searchResult} loader={loading} />
                                <div className="paginationWrapper">
                                    <Pagination totalRows={resultInfo.total_rows} fetchedRows={resultInfo.fetched_rows} totalPages={resultInfo.total_pages} pageSize={resultInfo.page_size} currentPage={resultInfo.current_page} onPageSelect={onPageSelect} label={category_page_labels?.category_page_pagination_label} loader={loading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Layout>
    )
}
export default CategoriesPage;